import React from 'react';

import { TABS_THEME } from '../../tabs/constants';
import Tabs from '../../tabs/tabs';

import './carousel__filter.scss';

interface Props<FilterValue> {
    mix?: string;
    filterList: { title: string; value: FilterValue }[];
    selectedFilter: FilterValue;
    onFilterChange: (value: FilterValue) => void;
}

export function CarouselFilter<P>({ mix, filterList, selectedFilter, onFilterChange }: Props<P>) {
    return (
        <div className={mix}>
            <Tabs mix="carousel__filter-tabs" theme={TABS_THEME.ROUNDED}>
                {filterList.map(({ title, value }, index) => (
                    <Tabs.Tab
                        id={index}
                        key={title}
                        mix="carousel__filter-tab"
                        onTabSelect={() => onFilterChange(value)}
                        selected={selectedFilter === value}
                    >
                        <button aria-selected={selectedFilter === value} className="carousel__filter-button-reset-css">
                            {title}
                        </button>
                    </Tabs.Tab>
                ))}
            </Tabs>
        </div>
    );
}
